import { API_URL } from '@portal/config/env';
import {
  getCleanInstance,
  getInstance,
} from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/settings';

const SettingsApi = {
  get: async (): Promise<models.Settings> => {
    const instance = getInstance();
    const { data } = await instance.get<models.Settings>(BASE_URL);

    return data;
  },

  getRemoteConfig: async () => {
    const instance = getInstance();
    const { data } = await instance.get<{ app: models.RemoteConfig }>(
      `${BASE_URL}/remote-config`
    );

    return data.app;
  },

  setKeys: async (key: string[]) => {
    const instance = getCleanInstance(API_URL);
    const { data } = await instance.post<models.SettingsKeys>(
      `${BASE_URL}/key`,
      { key }
    );

    return data;
  },
};

export default SettingsApi;
